<template>
    <div class="component-buy-orders-pop-up">
        <vs-popup title="Quero Conhecer"
            :active.sync="isActive"
            @close="$emit('isActiveFalse')"
            style="border-radius: 10px !important; z-index: 99999999999999999999!important"
            class="sizePopup"
        >
          <div class="headline">
            <h4>
              NOVIDADE: Agora você pode ter um número oficial e validado pelo whatsapp ✅
            </h4>
            <p class="mt-2">
              Tenha uma conexão que não tem quedas e travamentos!!! Utilize a integração oficial do whatsapp,
              com a melhor tecnologia do mercado.
            </p>
            <vs-alert
                title="Aviso"
                active="true"
                class="mb-8 mt-8"
                color="warning"
                style="height: auto"
            >
              Deixe seus contatos e nosso time vai te mostrar essa exclusividade que estamos entregando para você!
            </vs-alert>
          </div>
          <div class="contact-form">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  icon-pack="feather"
                  icon="icon-user"
                  icon-no-border
                  label-placeholder="Nome"
                  v-model="formData.full_name"
                  v-validate="'required'"
                  name="nome"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('nome')"
                >
                  {{ errors.first('nome') }}
                </span>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  icon-pack="feather"
                  icon="icon-phone"
                  icon-no-border
                  label-placeholder="Telefone"
                  v-model="formData.phone_number"
                  v-mask="phoneNumberMask"
                  v-validate="'required|min:14'"
                  name="telefone"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('telefone')"
                >
                  {{ errors.first('telefone') }}
                </span>
              </div>
            </div>

            <div class="vx-row mt-5">
              <div class="vx-col w-full">
                <vs-button class="mr-3 mb-2" @click="submitForm" :disabled="!isFormValid">Enviar</vs-button>
              </div>
            </div>
          </div>
        </vs-popup>
    </div>
</template>

<script>
  import supportEmail from '@/http/requests/supportEmail'

  export default {
    name: 'BuyApiCloudPopUp',
    props: {
      isActive: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        isMounted: false,
        formData: {
          full_name: '',
          phone_number: ''
        }
      }
    },
    computed: {
      isFormValid() {
        return !this.errors.any()
      },
      phoneNumberMask() {
        if (this.formData.phone_number.startsWith('0800') || this.formData.phone_number.startsWith('(08) 00')) {
          return '#### ### ####'
        }
        else if (this.formData.phone_number.startsWith('800') || this.formData.phone_number.startsWith('(80) 0')) {
          return '### ### ####'
        }
        return ['(##) ####-####', '(##) #####-####']
      }
    },
    methods: {
      submitForm() {
        const formData = this.$_.cloneDeep(this.formData);

        this.$validator.validateAll().then(result => {
          if (result) {
            supportEmail.sendBuyApiCloudEmail(formData).then(() => {
              this.formData = {
                full_name: '',
                phone_number: ''
              }

              this.errors.clear()
              this.$validator.reset()

              this.$vs.notify({
                color: 'success',
                title: 'Sua mensagem foi enviada com sucesso!',
                text: 'Em breve nossa equipe irá entrar em contato!'
              })
              this.$emit('isActiveFalse')
            }).catch((error) => { console.error(error) })
          }
        })
      }
    },
  }
</script>
